// Alternate typefaces load on demand, each as its own chunk. The defaults are
// imported in main.tsx so first paint never waits on a choice.
export const fontLoaders: Record<string, () => Promise<unknown>> = {
  // Display serifs bring their italic too, for the serif eyebrow.
  newsreader: () => Promise.all([import('@fontsource-variable/newsreader'), import('@fontsource-variable/newsreader/wght-italic.css')]),
  fraunces: () => Promise.all([import('@fontsource-variable/fraunces'), import('@fontsource-variable/fraunces/wght-italic.css')]),
  'source-serif': () =>
    Promise.all([import('@fontsource-variable/source-serif-4'), import('@fontsource-variable/source-serif-4/wght-italic.css')]),
  geist: () => import('@fontsource-variable/geist'),
  'public-sans': () => import('@fontsource-variable/public-sans'),
  figtree: () => import('@fontsource-variable/figtree'),
  'roboto-slab': () => import('@fontsource-variable/roboto-slab'),
  atkinson: () => import('@fontsource-variable/atkinson-hyperlegible-next'),
  plex: () => import('@fontsource-variable/ibm-plex-sans'),
}

export function loadFont(id: string | undefined) {
  if (!id) return
  const loader = fontLoaders[id]
  if (loader) void loader().catch(() => undefined)
}
